import { ToggleButton, ToggleButtonGroup, clubbiStyled } from 'clubbi-ui'

interface StyledDeliveryDateProps {
  selected?: boolean
  disabled?: boolean
}

export const StyledSelectionContainer = clubbiStyled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  gap: '8px',
  padding: '0 16px',
  paddingTop: '24px',
  position: 'relative',
}))

export const StyledTitle = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 500,
  fontSize: '12px',
  justifyContent: 'space-between',
  width: '100% !important',
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.fontSizeXXS,
  },
}))

export const StyledDeliveryDate = clubbiStyled('span', {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'disabled',
})<StyledDeliveryDateProps>(({ theme, selected, disabled }) => ({
  fontWeight: selected ? 600 : 400,
  fontSize: '13px',
  color: disabled ? theme.palette.brandGrey[60] : theme.palette.brandBlack.main,
}))

export const StyledTag = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 400,
  lineHeight: '110%',
}))

export const StyledPriceContainer = clubbiStyled('div')<{
  selected: boolean
  disabled: boolean
  freeShipping: boolean | undefined
}>(({ theme, selected, disabled, freeShipping }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'end',
  lineHeight: '110%',
  fontSize: '12px',
  color: freeShipping
    ? theme.palette.brandSuccess[70]
    : disabled
    ? theme.palette.brandGrey[60]
    : theme.palette.brandGrey[100],

  fontWeight: selected ? 600 : 400,
}))

export const StyledToggleButtonGroup = clubbiStyled(ToggleButtonGroup)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  position: 'relative',
  gap: '8px',
}))

export const StyledToggleButton = clubbiStyled(ToggleButton)(({ theme }) => ({
  textTransform: 'none',
  width: '100%',
  height: '35px',
  fontSize: theme.typography.fontSize2XS,
  fontWeight: 400,
  borderRadius: '4px !important',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  border: `1px solid ${theme.palette.brandGrey[20]} !important`,
  backgroundColor: theme.palette.brandWhite.main,
  color: theme.palette.brandBlack.main,

  '&.Mui-selected': {
    border: `1px solid ${theme.palette.brandPurple.main} !important`,
    backgroundColor: theme.palette.brandWhite.main,
    fontWeight: '600 !important',
  },
  '&.Mui-selected span': {
    fontWeight: '600 !important',
  },

  '&.Mui-disabled': {
    border: `2px dashed ${theme.palette.brandGrey[20]} !important`,
    color: theme.palette.brandGrey[60],
    fontWeight: 400,
    opacity: 0.8,
  },

  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.fontSizeXXS,
  },
}))

export const StyledType = clubbiStyled('div')(() => ({
  textAlign: 'initial',
  flex: '1 !important',
}))
